module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "m-header"
  }, [_c('div', {
    staticClass: "m-header__translate"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row text-right"
  }, [_c('img', {
    class: [{
      'low-opacity': this.$i18n.locale !== 'pt'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-brazil-32.png'
    },
    on: {
      "click": function($event) {
        return _vm.setLocale('pt')
      }
    }
  }), _vm._v(" "), _c('img', {
    class: [{
      'low-opacity': this.$i18n.locale !== 'en'
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": this.$config.imgDir + '/flag-usa-32.png'
    },
    on: {
      "click": function($event) {
        return _vm.setLocale('en')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "m-header__logo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center m-info__title"
  }, [_c('img', {
    attrs: {
      "src": _vm.$config.logo
    }
  })])])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-inverse m-navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse m-navbar__collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Homepage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.home")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ParksPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.parks")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'CompaniesPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.companies")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AboutPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.about")))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ContactPage'
      },
      "tag": "li",
      "exact": ""
    }
  }, [_c('a', [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.contact")))])])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('button', {
    staticClass: "btn navbar-btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("navbar.login")))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8860b64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Header.vue
// module id = 707
// module chunks = 1